import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledCollapse, Card, CardHeader, CardBody } from 'reactstrap';
import { TablaCabeceraPractica } from './TablaCabeceraPractica';
import { TablaPromedios } from './TablaPromedios';
import { GraficoBarras } from './GraficoBarras';
import { GraficoBarrasApiladas } from './GraficoBarrasApiladas';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class Practica extends Component {

    constructor(props) {
        super(props);
        this.state = { practica: null, datos: [], areas: [], frecuencias: [], alternativas: [], modo: "view", loading: true };
    }

    componentDidMount() {
        document.title = TITLE + " - Histórico por tutor";
        const anio = this.props.match.params["anio"];
        const codigo = this.props.match.params["codigo"];
        const identificacion = this.props.match.params["identificacion"];
        const modo = this.props.match.params["modo"] || "view";
        this.populateData(anio, codigo, identificacion, modo);
    }

    toggle(area) {
        const i = this.state.areas.indexOf(area);
        this.setState(({ areas }) => ({
            areas: [
                ...areas.slice(0, i),
                {
                    ...areas[i],
                    comparativo: !areas[i].comparativo,
                },
                ...areas.slice(i + 1)
            ]
        }));
    }

    formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    splitwords(text, size = 40) {
        if (text.length <= size)
            return text;
        const chunks = text.split(" ");
        const parts = [];
        var aux = "";
        for (var c in chunks) {
            if (aux.length + chunks[c].length <= size) {
                aux += chunks[c] + " ";
            }
            else {
                parts.push(aux);
                aux = chunks[c] + " ";
            }
        }
        parts.push(aux);
        return parts;
    }

    renderTable(practica, datos, areas, frecuencias, alternativas) {
        //console.log(datos);
        return (
            <>
                <TablaCabeceraPractica practica={practica} />
                {areas && areas.map((a) => {
                    const preguntas = datos.filter(p => a.idarea == p.idarea);
                    
                    const etiquetas = preguntas.map((p, index) => index + 1);
                    const valoresFrecuencias = frecuencias.filter(f => f.idarea == a.idarea).map(p => { return { ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa, frecuencia: p.frecuencia } });
                    const valoresPuntaje = preguntas.map(p => this.formatter(p.porcentaje * 100));
                    return (
                        <div key={"d_" + a.idarea}>
                            <TablaPromedios key={"t_" + a.idarea} area={a} preguntas={preguntas} />
                            
                            {this.state.modo == "view" ?
                                <>
                                    <Button id={"tg_" + a.idarea}>Ver gráfico</Button>
                                    <UncontrolledCollapse toggler={'#tg_' + a.idarea}>
                                        <Card>
                                            <CardBody>
                                                <GraficoBarrasApiladas key={"gf_" + a.idarea} titulo={a.area} labels={etiquetas} values={valoresFrecuencias} evaluados={practica.evaluados} />
                                            </CardBody>
                                        </Card>
                                    </UncontrolledCollapse>
                                </>
                                :
                                <GraficoBarrasApiladas key={"gf_" + a.idarea} id={"gf_" + a.idarea} animation={false} titulo={a.area} labels={etiquetas} values={valoresFrecuencias} evaluados={practica.evaluados} />
                            }
                            <br />
                            <Modal key={"m_" + a.idarea} isOpen={a.comparativo} className="modal-xl">
                                <ModalHeader>Gráfico comparativo</ModalHeader>
                                <ModalBody>
                                    <GraficoBarras key={"g_" + a.idarea} title={a.area} labels={etiquetas} values={valoresPuntaje} respuestas={practica.evaluados} />
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="secondary" onClick={() => this.toggle(a)}>
                                        Cerrar
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </div>
                    );
                })}

            </>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.practica, this.state.datos, this.state.areas, this.state.frecuencias, this.state.alternativas);

        return (
            <div className="d-flex">
                <div>
                    <h1 id="tabelLabel" className="text-center">Reporte por Tutor</h1>
                    {contents}
                </div>
            </div>
        );
    }

    async populateData(anio, codigo, identificacion, modo) {
        const response = await fetch(`${APIURL}/api/reportes/practica/${anio}/${codigo}/${identificacion}`);
        const data = await response.json();

        const dataResponse = await fetch(`${APIURL}/api/reportes/practica-detalle/${anio}/${codigo}/${identificacion}`);
        const dataPractica = await dataResponse.json();
        const areas = [];
        dataPractica.forEach(p => {
            if (areas.every(a => a.idarea !== p.idarea)) {
                areas.push({ idarea: p.idarea, area: p.area, comparativo: false });
            }
        });

        const frecuenciasResponse = await fetch(`${APIURL}/api/reportes/practica-frecuencias/${anio}/${codigo}/${identificacion}`);
        const dataFrecuencias = await frecuenciasResponse.json();
        const alternativas = [];
        dataFrecuencias.forEach(p => {
            if (alternativas.every(e => e.ordenAlternativa !== p.ordenAlternativa)) {
                alternativas.push({ ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa });
            }
        });

        if (dataPractica && dataFrecuencias) {
            this.setState({ practica: data, datos: dataPractica, areas: areas, frecuencias: dataFrecuencias, alternativas: alternativas, modo: modo, loading: false });
        }

    }
}
